if (!customElements.get('scd-featured-slider')) {
  customElements.define(
    'scd-featured-slider',
    class ScdFeaturedSlider extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.enableSlider = this.dataset.enableSlider === 'true';
        this.layout = this.dataset.layout || 'product';
        if (!this.enableSlider) return;

        const slider = this.querySelector('.swiper');
        if (!slider) return;

        const section = this.closest('.section');

        const isBannerLayout = this.layout === 'banner';
        const options = {
          slidesPerView: isBannerLayout ? 1.08 : 1,
          spaceBetween: isBannerLayout ? 8 : 24,
          navigation: {
            nextEl: section.querySelector('.scd-swiper-next'),
            prevEl: section.querySelector('.scd-swiper-prev'),
          },
          pagination: {
            el: this.querySelector('.swiper-pagination'),
            clickable: true,
          },
          breakpoints: {
            1024: {
              slidesPerView: isBannerLayout ? 1.35 : 2,
              spaceBetween: isBannerLayout ? 8 : 40,
            },
          },
          loop: true,
          threshold: 2,
        };

        this.sliderInstance = new window.FoxTheme.Carousel(slider, options);
        this.sliderInstance.init();
      }
    }
  );
}
